import React, { Component } from "react";
import { withRedux, isLoading } from "helpers";
import Spinner from "./Spinner";

class NProgress extends Component {
  state = {
    count: 0,
  };

  handleClick = () => {
    const { count } = this.state;

    if (count === 5) {
      isLoading(false);
      this.setState({ count: 0 });
    } else {
      this.setState({ count: count + 1 });
    }
  };

  render() {
    const { isLoading } = this.props;

    return <Spinner onClick={this.handleClick} progress={isLoading} />;

    // return (
    //   <NProgress isAnimating={isLoading} key={location.key}>
    //     {({ isFinished, progress, animationDuration }) => (
    //       <Container
    //         isFinished={isFinished}
    //         animationDuration={animationDuration}
    //       >
    //         {/* <Bar
    //           progress={progress}
    //           animationDuration={animationDuration}
    //         /> */}
    //         <Spinner
    //           progress={progress}
    //           animationDuration={animationDuration}
    //         />
    //       </Container>
    //     )}
    //   </NProgress>
    // );
  }
}

export default withRedux(NProgress);
